import GenericPageError from './GenericPageError';

export default GenericPageError;
